import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { message } from 'antd';

// 墨西哥时区 (CST - Central Standard Time, UTC-6)
const MEXICO_TIMEZONE_OFFSET = -6; // UTC-6

/**
 * 将UTC时间转换为墨西哥时区时间
 * @param utcTime UTC时间字符串或Date对象
 * @returns 墨西哥时区的时间字符串
 */
export const formatMexicoTime = (utcTime: string | Date): string => {
  const date = new Date(utcTime);

  // 创建墨西哥时区的时间
  const mexicoTime = new Date(date.getTime() + (MEXICO_TIMEZONE_OFFSET * 60 * 60 * 1000));

  return mexicoTime.toLocaleString('es-MX', {
    timeZone: 'America/Mexico_City',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/**
 * 获取当前墨西哥时间
 */
export const getMexicoTime = (): Date => {
  const now = new Date();
  return new Date(now.getTime() + (MEXICO_TIMEZONE_OFFSET * 60 * 60 * 1000));
};

// 从环境变量或默认值获取API地址
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// 创建axios实例
const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 添加token到请求头
    const token = localStorage.getItem('access_token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 对于FormData，删除Content-Type让浏览器自动设置
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  async (error) => {
    const { response } = error;
    
    if (response?.status === 401) {
      // 收到401错误，立即清除本地存储并跳转到登录页面
      // 不尝试刷新token，避免死循环
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_info');
      
      // 如果当前不在登录页面，则跳转到登录页面
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      
      return Promise.reject(error);
    } else if (response?.data?.error) {
      // 显示服务器返回的错误信息
      message.error(response.data.error);
    } else {
      // 显示通用错误信息
      message.error('请求失败，请稍后重试');
    }
    
    return Promise.reject(error);
  }
);

export default request;
